import type { SVGProps } from 'react'

export const CloudApproveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2061_4408)">
      <path
        d="M7.33334 12.0026H4.438C2.72334 12 1.33334 10.662 1.33334 9.0113C1.33334 7.3613 2.72334 6.0233 4.438 6.0233C4.7 4.84863 5.634 3.88996 6.888 3.50796C8.14134 3.12663 9.52534 3.3793 10.5173 4.17463C11.5093 4.96796 11.9587 6.1793 11.6973 7.35396H12.3573C13.2827 7.35396 14.0807 7.90063 14.4493 8.69196"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 12.6667L11.3333 14L14 11.3334" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
)
